<template>
  <div class="auth-failed">
    <van-tabs @click="changeTab">
      <van-tab name="" title="全部"></van-tab>
      <van-tab name="1" title="待升级"></van-tab>
      <van-tab name="2" title="待审核"></van-tab>
    </van-tabs>
    <div ref="listBox" class="list-box" :style="{ height: `${listBoxH}` }">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div v-for="(item, index) in list" :key="index" class="item">
            <div class="title">{{ item.merName }}</div>
            <div class="filed">
              <div class="lable">商户编号</div>
              <div class="value">{{ item.merchantNo }}</div>
            </div>
            <div class="filed">
              <div class="lable">机具编号</div>
              <div class="value">{{ item.snCode }}</div>
            </div>
            <div class="filed">
              <div class="lable">激活状态</div>
              <div class="value">{{ item.activeStatus }}</div>
            </div>
            <div class="filed">
              <div class="lable">商户注册时间</div>
              <div class="value">{{ item.registryTime }}</div>
            </div>
            <div class="filed">
              <div class="lable">入网状态</div>
              <div class="value">
                <span class="red">{{ item.entryStatusDesc }}</span>
                <span
                  v-if="[2, 4, 5].includes(Number(item.entryStatus))"
                  class="valBtn"
                  @click="goPage(item)"
                >
                  协助升级
                </span>
              </div>
            </div>
            <div
              class="filed"
              v-if="[2, 4, 5].includes(Number(item.entryStatus))"
            >
              <div class="lable">进件失败原因</div>
              <div class="value" :id="`tip${index}`">
                <span class="ellipsis">
                  {{ item.entryDesc }}
                </span>
                <van-popover
                  v-model="item.showPop"
                  trigger="click"
                  theme="dark"
                  :get-container="`#tip${index}`"
                  placement="top-end"
                >
                  <template #reference>
                    <van-icon name="info-o" />
                  </template>
                  <template #default>
                    <div class="popover-notify-content">
                      <p style="text-align: left">
                        {{ item.entryDesc }}
                      </p>
                    </div>
                  </template>
                </van-popover>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import { storeAssistEntryGetAssistEntryList } from '@/api/assist-operation'
export default {
  data() {
    return {
      listBoxH: '',
      refreshing: false,
      loading: false,
      finished: false,

      list: [],

      searchEntryStatus: '',
      pageNum: 0,
      pageSize: 10
    }
  },
  created() {},
  mounted() {
    this.getElementTop()
  },
  methods: {
    goPage(item) {
      if (item.snCode) {
        this.$router.push({
          path: '/assist-operation',
          query: {
            assistEntryId: item.assistEntryId,
            snCode: item.snCode
          }
        })
      } else {
        this.$router.push({
          path: '/assist-operation/choose-sn',
          query: {
            assistEntryId: item.assistEntryId,
            snCode: item.snCode
          }
        })
      }
    },
    getData() {
      let params = {
        searchEntryStatus: this.searchEntryStatus,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      console.log(params)
      storeAssistEntryGetAssistEntryList(params).then(res => {
        console.log(res)
        this.list = this.list.concat(res)
        if (res.length < this.pageSize) {
          this.finished = true
        } else {
          this.finished = false
        }
        this.loading = false
      })
    },
    changeTab(e) {
      console.log(e)
      this.searchEntryStatus = e
      this.onRefresh()
    },
    onRefresh() {
      setTimeout(() => {
        this.loading = false
        this.refreshing = false
      }, 1500)
      this.pageNum = 1
      this.list = []
      this.getData()
    },
    onLoad() {
      this.pageNum++
      this.getData()
    },
    getElementTop() {
      let el = this.$refs.listBox
      this.listBoxH = `calc(100vh - ${el.offsetTop}px)`
    }
  }
}
</script>
